import IkeaAPI from '../../../static/ikea-product-feed/ikea-product-feed';
import { IIkeaAPI, IkeaProductCard, IProductFeedPayload } from './interfaces';

const fetchIkeaProductFeed = async (
  node_locale: string,
  businessUnitCode?: string,
  primaryLanguage?: string,
  numberOfItem?: number,
) => {
  const payload: IProductFeedPayload = {
    rating_value: parseFloat(
      process.env.GATSBY_IKEA_PRODUCT_RATING_VALUE || '0',
    ),
    breathtakingitem:
      process.env.GATSBY_IKEA_PRODUCT__BREATHTAKING_ITEM === 'true',
    isNew: process.env.GATSBY_IKEA_PRODUCT__IS_NEW === 'true',
    isTopSeller: process.env.GATSBY_IKEA_PRODUCT__IS_TOPSELLER === 'true',
    isLastChance: process.env.GATSBY_IKEA_PRODUCT__IS_LASTCHANCE === 'true',
    newLowerPrice: process.env.GATSBY_IKEA_PRODUCT__NEW_LOWER_PRICE === 'true',
    isLimitEdition:
      process.env.GATSBY_IKEA_PRODUCT__IS_LIMITED_EDITION === 'true',
    timeRestrictedOffer:
      process.env.GATSBY_IKEA_PRODUCT__TIME_RESTRICTED_OFFER === 'true',
    numberOfItem:
      numberOfItem ||
      parseInt(process.env.GATSBY_IKEA_PRODUCT__NUMBER_OF_ITEM || '0'),
    businessUnitCode: businessUnitCode || '',
    primaryLang: primaryLanguage || '',
    locale: node_locale,
  };
  const url =
    process.env.IKEA_PRODUCTS_API_ENDPOINT ||
    process.env.GATSBY_IKEA_PRODUCTS_API_ENDPOINT;
  const client = new IkeaAPI({ baseURL: url }) as IIkeaAPI;

  const fetchedProducts = await client.getProducts(payload);
  if (fetchedProducts) {
    return fetchedProducts.data as IkeaProductCard[];
  } else {
    return [];
  }
};

export default fetchIkeaProductFeed;
